import api from "./api";


export const Entrycameramonitor = {

    getLiveAlerts(payload) {
        return api.put(`/facial/get_live_logs`, payload);

    },
    getLiveAlertss(payload) {
        return api.put(`/facial/get_live_logss`, payload);

    },
    getCameraStatus(payload) {
        return api.put(`/facial/camera_status`, payload);
    },
    upDateStatus(payload) {
        return api.put('/facial/update_log_verification', payload);
    },
    getLivecounts(payload) {
        return api.put(`/facial/get_logs_count`, payload);

    },

    getLivesop_stats(payload) {
        return api.put(`/facial/get_sop_stats`, payload);

    },
    getAllEmplyoes(payload) {
        return api.put(`/facial/get_all_employes`, payload);
    },
    getStats(payload) {
        return api.put(`/facial/get_stats`, payload);
    },
    blacklistToggle(payload) {
        return api.put(`facial/blacklist_toggle`, payload);
    }
}
